import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { createQueryLoader } from '@/loader';
import StartPageQueryNode, {
  type StartPageQuery,
} from '@/pages/start/__generated__/StartPageQuery.graphql';
import StartPage from '@/pages/start/StartPage';
import {
  getStartDraftVariables,
  startSearchSchema,
} from '@/pages/start/utils/start-search';
import { buildPageMeta } from '@/utils/seo';

const loadStartPage = createQueryLoader<StartPageQuery>(StartPageQueryNode, {
  fetchPolicy: 'store-or-network',
});

const startTitle = 'Start with your rental property — Budgy';
const startDescription =
  'Enter your rental address to compare local letting agents. Nothing goes to an agent without your sign-off.';
const defaultStartStep = 1;

export const Route = createFileRoute('/start')({
  validateSearch: startSearchSchema,
  search: {
    middlewares: [stripSearchParams({ step: defaultStartStep })],
  },
  loaderDeps: ({ search }) => ({ draftId: search.draftId }),
  loader: ({ context, deps }) =>
    loadStartPage({
      environment: context.relayEnvironment,
      variables: getStartDraftVariables(deps.draftId),
    }),
  component: StartPage,
  head: () => {
    const pageMeta = buildPageMeta({
      title: startTitle,
      description: startDescription,
      path: '/start',
    });

    return {
      ...pageMeta,
      meta: [...pageMeta.meta, { name: 'robots', content: 'noindex, follow' }],
    };
  },
});
